<template>
  <div>
    <vx-card class="mb-4">
      <validation-observer ref="validator" #default="{valid}">
        <b-form
          :class="[inline ? 'gap-2 items-center' : '']"
          :inline="inline"
          @submit.prevent="createOrUpdate"
          @reset.prevent="clearForm">

          <validation-provider
            #default="validationContext"
            name="name"
            rules="required"
            class="flex-grow"
            slim>
            <b-form-group
              :class="[inline ? 'flex-col items-start pb-1 inline-input-group': '']"
              id="input-group-1"
              :label="$t('modality.name')"
              label-for="name">
              <b-form-input
                class="pr-0 w-full"
                id="name"
                type="text"
                v-model="model.name"
                :state="getValidationState(validationContext)"></b-form-input>
              <b-form-invalid-feedback :class="[{'absolute': inline}]">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="description"
            rules="max:128"
            class="flex-grow"
            slim>
            <b-form-group
              :label="$t('modality.description')"
              label-for="description"
              :class="[inline ? 'flex-col items-start pb-1 inline-input-group': '']">
              <b-form-textarea
                id="description"
                class="pr-0 w-full"
                v-model="model.description"
                 rows="3"
                max-rows="6"
                :state="getValidationState(validationContext)"/>
              <b-form-invalid-feedback :class="[{'absolute': inline}]">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <b-form-row :class="['justify-center', inline ? 'ml-auto' : '' ]" v-if="id">
            <b-col cols="auto">
              <label class="w-full text-left block"> Logo </label>
              <image-upload
                class="border-faint-grey border-solid border p-2 rounded-lg"
                maxHeight="100px"
                maxWidth="200px"
                v-model="imageData"
                :key="logoUploadURL"
                :uploadUrl="logoUploadURL"
                @upload-complete="uploadLogoSuccess"/>
            </b-col>
          </b-form-row>

            <b-form-row :class="['justify-end mt-2', inline ? 'ml-auto' : '' ]">
              <b-col cols="auto">
                  <b-button :disabled="!valid" type="submit" variant="primary">
                    <slot name="submit-button-text">Salvar</slot>
                  </b-button>
              </b-col>
              <b-col cols="auto">
                <b-button type="reset" variant="outline-secondary">
                  <slot name="reset-button-text">Limpar</slot>
                </b-button>
              </b-col>
              <b-col cols="auto">
                <b-button
                  variant="outline-secondary"
                  class="float-right"
                  @click="goBack">
                  <feather-icon
                    icon="CornerUpLeftIcon"
                    class="mr-50"/>
                  <span class="align-middle">{{$t('back')}}</span>
                </b-button>
              </b-col>
            </b-form-row>
        </b-form>
      </validation-observer>
    </vx-card>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BFormRow,
  BCol,
  BFormInvalidFeedback,
  BInputGroup,
  BInputGroupAppend
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import { required, min, max } from '@validations'
import ImageUpload from '@/components/ImageUpload.vue'

import ModalityService from '@/services/api/ModalityService'

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BFormRow,
    BCol,
    BFormInvalidFeedback,
    ValidationObserver,
    ValidationProvider,
    BInputGroup,
    BInputGroupAppend,
    ImageUpload
  },

  props: {
    id: {
      type: Number,
      default: null
    },
    showSubmit: {
      type: Boolean,
      default: true
    },
    showReset: {
      type: Boolean,
      default: true
    },
    inline: {
      type: Boolean,
      default: false
    },
    inlineInput: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    model: {
      id: null,
      name: '',
      description: ''
    },
    imageData: '',
    required, min, max
  }),

  methods: {
    loadData(id) {
      this.$vs.loading()
      this.service.read(id).then(
        response => {
          this.model.id = response.id
          this.model.name = response.name
          this.model.description = response.description
          //
          this.imageData = this._.get(response, 'logo_url')
        },
        error => {this.$vs.loading.close()}
      ).finally(() => {this.$vs.loading.close()})
    },
    createOrUpdate() {
      this.$vs.loading()

      const modelData = {
        id: this.id,
        name: this.model.name,
        description: this.model.description,
      }

      this.service.createOrUpdate(modelData).then(
        data => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          if(!this.isEdit){
            this.$router.push(`/modalities/${data.id}/edit`)
          }
        },
        error => {
          this.showErrors(this.$validator, error, this)
          //this.notifyError(this.$vs,this.$t('messages.error'))
        }
      ).finally(() => { this.$vs.loading.close() })
    },
    clearForm() {
      this.clearValidationErrors()
      this.$emit('reset')
      this.model.name = ''
      this.model.description = ''
    },
    goBack() {
      this.$router.push('/modalities')
    },
    isEdit() {
      return !_.isNil(this.id)
    },
    getValidationState({ invalid, validated, ...obj }){
      const valid = !invalid
      return (
        !validated ? null : valid
      )
    },
    showValidationErrors(error) {
      this.showErrors(this.$refs.validator, error)
    },
    clearValidationErrors() {
      this.$refs.validator.reset()
    },
    uploadLogoSuccess() {
      this.notifySuccess(this.$vs, this.$t('messages.success'), 5000)
    },
  },
  computed: {
    logoUploadURL() {
      const base = `${process.env.VUE_APP_API_BASE_URL}/api/v1`
      return `${base}/modalities/${this.id}/logo`
    }
  },
  watch: {
  },
  beforeMount() {
    this.service = ModalityService.build(this.$vs)
  },
  mounted() {
    if (this.id) {
      this.loadData(this.id)
    }
  }
}
</script>

<style lang="scss">
  .inline-input-group > div:nth-child(2) {
    width: 100%;
  }
</style>
